
function Tabs() {
    if (document.querySelector('.tabs') !== null) {
        this.init();
    }
}

Tabs.prototype.init = function()
{
    var nav = document.querySelectorAll('.tabs .tabs__nav span');
    var that = this;

    Array.prototype.forEach.call(nav, function (navItem) {
        navItem.addEventListener("click", function () {
            that.showTab(navItem);
            that.updateNavigation(navItem);
        });
    });
}

Tabs.prototype.showTab = function(navItem)
{
    var current = document.querySelector('.tabs__content div.active');

    if (current) {
        current.classList.remove('active');
    }

    var newTabClass = navItem.classList.item(0);
    var newTab = document.querySelector('.tabs__content div.' + newTabClass);

    if (newTab) {
        newTab.className += " active";
    }
}

Tabs.prototype.updateNavigation = function(navItem)
{
    var current = document.querySelector('.tabs__nav span.active');

    if (current) {
        current.classList.remove('active');
    }

    navItem.className += " active";
}


export default Tabs;



// WEBPACK FOOTER //
// ./js/components/tabs/index.js